import { render } from "./BaseTextArea.vue?vue&type=template&id=2b5e2faf&scoped=true"
import script from "./BaseTextArea.vue?vue&type=script&lang=js"
export * from "./BaseTextArea.vue?vue&type=script&lang=js"

import "./BaseTextArea.vue?vue&type=style&index=0&id=2b5e2faf&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2b5e2faf"]])

export default __exports__